import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSidebarData } from '../../../hooks/sidebarData';
import { useQuery } from '@tanstack/react-query';
import axios from '../../../api/axios';
import { destroySession } from '../../../helpers/Session';

const NDOTApproval = () => {
    const navigate = useNavigate();
    const { sidebarData } = useSidebarData();
    
    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');

    const { data: approvals, isLoading, error } = useQuery({
        queryKey: ['userNDOTRequestApprovals', { sidebarData }],
        queryFn: async () => {
            const res = await axios.get(`ndot/approvals/${sidebarData.data?.uname}?id=${sidebarData.data?.ndotrequestid}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!sidebarData.data?.uname && !!sidebarData.data?.ndotrequestid && !!accesstoken,
        retry: 1
    });

    useEffect(() => {
        if (error) {
            if (error.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [error]);

    return (
        <div className={`approvers ${isLoading ? 'loading' : ''}`}>
            {sidebarData.data?.sdate && (<h3 className='title'>{sidebarData.data?.sdate} - {sidebarData.data?.edate}</h3>)}

            {isLoading
                ? (
                    [...Array(2)].map((_, i) => (
                        <div key={i} className="approver">
                            <p className="sequence">Approver {i + 1}</p>
                            <h3>Resty Alejo</h3>
                        </div>
                    ))
                ) : approvals?.length > 0 && approvals?.map((item, i) => (
                        <div key={i} className={`approver ${item.status === 0 ? 'pending' : item.status === 1 ? 'approved' : item.status === 2 ? 'disapproved' : item.status === 3 ? 'cancelled' : ''}`}>
                            <p className="sequence">Approver {i + 1}</p>
                            <h3>{item.name}</h3>
                            <p className={`status ${item.status === 0 ? 'pending' : item.status === 1 ? 'approved' : item.status === 2 ? 'disapproved' : item.status === 3 ? 'cancelled' : ''}`}>
                                {item.status === 0 
                                    ? 'Pending' 
                                    : item.status === 1 
                                        ? 'Approved'
                                        : item.status === 2 
                                            ? 'Disapproved' 
                                            : item.status === 3 
                                            ? 'Cancelled' 
                                            : ''
                                }
                            </p>
                        </div>
                ))
            }
        </div>
    )
}

export default NDOTApproval;